import { api } from "../../api/api"
import { GET_FOLDER_REQUEST, GET_FOLDER_SUCCESS } from "../constant"

export const getFolders=()=>{
    return async (dispatch)=>{
        dispatch({
            type:GET_FOLDER_REQUEST,
            payload:''
        })
        const {status,data}=await api.get('/folder/getFolders');
        if(status==200){
            dispatch({
                type:GET_FOLDER_SUCCESS,
                payload:data.folders
            })
        }
    }
}